import * as Framework from './states/Framework/Framework';
import Specs, { ISpecsState } from './states/Specs/SpecsSlice';
import RDWVehicle, { IRDWVehicleState } from './states/RDWVehicle/RDWVehicleSlice';
import AdditionalServices, { IServicesState } from './states/AdditionalServices/AdditionalServicesSlice';
import Appointment, { IAppointmentState } from './states/Appointment/AppointmentSlice';
import Customer, { ICustomerState } from './states/Customer/CustomerSlice';
import Menus, { IMenusState } from './states/MaintenanceMenus/MaintenanceMenusSlice';
import RepairOrders, { IRepairOrdersState } from './states/RepairOrders/RepairOrdersSlice';
import Vehicles, { IVehiclesState } from './states/Vehicles/VehiclesSlice';
import NewVehicle, { INewVehicleState } from './states/NewVehicle/NewVehicleSlice';
import ROHistory, { IROHistoryState } from './states/ROHistory/ROHistorySlice';
import QuickTimes, { IQuickTimesState } from './states/QuickTimes/QuickTimesSlice';
import WebOps, { IWebOpsState } from './states/WebOps/WebOpsSlice';
import RMTimes, { IrmTimesState } from './states/RMTimes/RMTimesSlice';
import ConnectedVehicle, { IConnectedVehicleState } from './states/ConnectedVehicle/ConnectedVehicleSlice';

export interface IStoreState {
    Appointment: IAppointmentState;
    Framework: Framework.IFrameworkState;
    Specs: ISpecsState;
    Menus: IMenusState;
    Vehicles: IVehiclesState;
    Customer: ICustomerState;
    NewVehicle: INewVehicleState;
    QuickTimes: IQuickTimesState;
    RMTimes: IrmTimesState;
    AdditionalServices: IServicesState;
    WebOps: IWebOpsState;
    ROHistory: IROHistoryState;
    RepairOrders: IRepairOrdersState,
    RDWVehicle: IRDWVehicleState,
    ConnectedVehicle: IConnectedVehicleState,
}

export const reducers = {
    Appointment: Appointment,
    Framework: Framework.reducer,
    Specs: Specs,
    Menus: Menus,
    Vehicles: Vehicles,
    Customer: Customer,
    NewVehicle: NewVehicle,
    QuickTimes: QuickTimes,
    RMTimes: RMTimes,
    AdditionalServices: AdditionalServices,
    WebOps: WebOps,
    ROHistory: ROHistory,
    RepairOrders: RepairOrders,
    RDWVehicle: RDWVehicle,
    ConnectedVehicle: ConnectedVehicle,
};

export const observers = [
];
